// @ts-nocheck
import { Box, Button, Stack, Tab, Tabs, Typography } from "@mui/material";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { DataGrid } from "UI/DataGrid";
import { columns, Container, mobileColumns } from "./ReferralDetails.data";
import { useReferralDetails } from "./ReferralDetails.hook";
import { TabPanel } from "./TabPanel";
import { ReferralDetailsTab } from "./ReferralDetailsTab";
import { ReferralMessages } from "./ReferralMessages";
import { FileList } from "./FileList";

export const ReferralDetails = () => {
  const {
    id,
    title,
    data,
    admins,
    marketers,
    schedulers,
    providers,
    hardButton,
    patient,
    isLoading,
    currentTab,
    handleChangeTab,
    dataGrid,
    getData,
    createdAt,
    status,
    note,
    buttonId,
    buttonType,
    practiceName,
    practiceSpeciality,
    practiceAddress,
    practicePhone,
    practiceMarketingRegion,
    originatorName,
    originatorPhone,
    originatorEmail,
    originatorJobTitle,
    recipientName,
    recipientPhone,
    recipientAddress,
    type,
    question,
    options,
    isResendButtonVisible,
    handleStatusChange,
    handleResendFormLink,
    isSuperAdmin,
    files,
    isAttachmentTabVisible,
    isProcessingSuggestionsVisible,
    startProcessing,
    declineProcessingSuggestions,
    locations,
  } = useReferralDetails();

  return (
    <CommonOutletTemplate
      noPadding
      title={title}
      backIcon
      backLink={isSuperAdmin ? "/referral_stream_data" : "/"}
    >
      <Container>
        <Box sx={{ flex: 0, borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={currentTab}
            onChange={handleChangeTab}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label={title} />
            {isAttachmentTabVisible && (
              <Tab
                label={`Attachments ${
                  files?.length > 0 ? `(${files?.length})` : ""
                }`}
              />
            )}
            <Tab label={"History logs"} />
          </Tabs>
        </Box>
        {!isLoading && data && (
          <Stack flex={0}>
            {isProcessingSuggestionsVisible && (
              <div
                className={[
                  "flex flex-row justify-between items-center",
                  "bg-green-200 text-green-800 p-2 px-4 mt-2 rounded-lg text-sm",
                  "border-solid border-green-600 border-b-2 border-r-2",
                ].join(" ")}
              >
                <Typography
                  variant="body1"
                  sx={{ flex: 1, fontWeight: "medium", minWidth: "200px" }} // Muted gold for text
                >
                  Would you like to start processing this {type?.toLowerCase() ?? "referral"}?
                </Typography>
                <Stack direction="row" flexWrap={"wrap"} gap={1}>
                  <Button
                    variant="outlined"
                    size="small"
                    color="success"
                    onClick={declineProcessingSuggestions}
                    sx={{ padding: "8px 20px", width: "100px", boxShadow: "none" }}
                  >
                    Not now
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={startProcessing}
                    color="success"
                    sx={{ padding: "8px 20px", width: "100px", boxShadow: "none" }}
                  >
                    Yes
                  </Button>
                </Stack>
              </div>
            )}
            <TabPanel value={currentTab} index={0}>
              <ReferralDetailsTab
                {...{
                  id,
                  admins,
                  marketers,
                  schedulers,
                  providers,
                  hardButton,
                  patient,
                  getData,
                  createdAt,
                  status,
                  note,
                  buttonId,
                  buttonType,
                  practiceName,
                  practiceSpeciality,
                  practiceAddress,
                  practicePhone,
                  practiceMarketingRegion,
                  originatorName,
                  originatorPhone,
                  originatorEmail,
                  originatorJobTitle,
                  recipientName,
                  recipientPhone,
                  recipientAddress,
                  type,
                  question,
                  options,
                  isResendButtonVisible,
                  handleStatusChange,
                  handleResendFormLink,
                  isSuperAdmin,
                  locations,
                }}
              />
            </TabPanel>
            {isAttachmentTabVisible && (
              <TabPanel value={currentTab} index={1}>
                <FileList files={files} referralId={id} />
              </TabPanel>
            )}
            <TabPanel value={currentTab} index={isAttachmentTabVisible ? 2 : 1}>
              <DataGrid
                columns={columns}
                mobileColumns={mobileColumns}
                handleRowClick={() => null}
                withRefreshButton
                {...dataGrid}
              />
            </TabPanel>
            {type !== "Notification" &&
              (["Virtual", "Soft", "Digital"].includes(buttonType) || !buttonId) && (
                <ReferralMessages
                  data={data}
                  {...{ admins, marketers, schedulers }}
                />
              )}
          </Stack>
        )}
      </Container>
    </CommonOutletTemplate>
  );
};
